import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { AlertController } from "@ionic/angular";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    public storage: Storage,
    public alertController: AlertController
  ) { 
    console.log('hola desde servicio local storage')
    this.initDB()
  }

  async initDB() {
    await this.storage.create();
  }

  async read(k:string) {
    let result: any;
    await this.storage.get(k)
      .then((res) => {
        console.log(`storage read ${k}: `);
        result = res;
      })
      .catch((err) => {
        console.log(`Error storage read ${k}: `, err);
        this.presentAlert('Error', `al leer local storage ${k}`, JSON.stringify(err));
      });
    return result;
  }

  async save(value: any, k: string) {
    console.log('Storage save key: ', k);
    const key = `${environment.LOCAL_STORAGE}-${k}`;
    let valueString = "";
    if (typeof value === "object") {
      valueString = JSON.stringify(value);
    } else {
      valueString = value;
    }
    await this.storage.set(key, valueString)
      .then((res) => {
        console.log(`Storage save ${key}: `);
      })
      .catch((err) => {
        console.log(`Error Storage save ${key}: `, err);
        this.presentAlert('Error', `al salvar en local storage ${key}`, JSON.stringify(err));
      });
  }

  async delete(key){
    console.log('Delete storage ',key);
    await this.storage.remove(key)
      .then((res)=>{
        console.log(`Storage ${key} removed`);
      })
      .catch((err)=>{
        console.log(`Error Storage remove ${key}: `, err);
        this.presentAlert('Error', `al borrar en local storage ${key}`, JSON.stringify(err));
      });
  }

  async presentAlert(titulo: string,subtitulo: string,mensaje: string) {
    const alert = await this.alertController.create({
      mode:'ios',
      header: titulo,
      subHeader: subtitulo,
      message: mensaje,
      buttons: ['OK']
    });
    alert.present();
  }

}
